"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionPayoutOrder = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const transformToDate_1 = require("../transformers/transformToDate");
let CommissionPayoutOrder = class CommissionPayoutOrder {
    orderId;
    routeName;
    commissionPercentage;
    commissionAmount;
    commissionValueInPricingCurrency;
    commissionCurrency;
    commissionCurrencyExchangeRate;
    valueInCommissionCurrency;
    createdAt;
    departureAt;
    orderTotalPrice;
    orderCurrency;
    orderPricingCurrency;
    orderPricingCountryId;
    orderCurrencyRate;
};
exports.CommissionPayoutOrder = CommissionPayoutOrder;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], CommissionPayoutOrder.prototype, "orderId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], CommissionPayoutOrder.prototype, "routeName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "commissionPercentage", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "commissionAmount", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "commissionValueInPricingCurrency", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "commissionCurrency", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "commissionCurrencyExchangeRate", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "valueInCommissionCurrency", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CommissionPayoutOrder.prototype, "createdAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CommissionPayoutOrder.prototype, "departureAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "orderTotalPrice", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "orderCurrency", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "orderPricingCurrency", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommissionPayoutOrder.prototype, "orderPricingCountryId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutOrder.prototype, "orderCurrencyRate", void 0);
exports.CommissionPayoutOrder = CommissionPayoutOrder = __decorate([
    (0, class_transformer_1.Exclude)(),
    (0, type_graphql_1.ObjectType)("CommissionPayoutOrder"),
    (0, type_graphql_1.InputType)("CommissionPayoutOrder")
], CommissionPayoutOrder);
//# sourceMappingURL=CommissionPayoutOrder.js.map